import {
  Component,
  Inject,
  InjectionToken,
  ViewChild,
  inject,
} from '@angular/core';
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { BaseComponent } from '../../../../../../shared/components/base-component';
import { UserViewMetadata } from '../../../../../../shared/sub-modules/user-views/models/user-view-metadata';
import { UserViewComponent } from '../../../../../../shared/sub-modules/user-views/components/user-view/user-view.component';
import { UserViewService } from '../../../../../../shared/sub-modules/user-views/services/user-view.service';
import { LinesService } from '../../services/lines-detail.service';
import { HttpClient } from '@angular/common/http';

/** Modal con las diferentes líneas */
@Component({
  selector: 'app-lines-detail-modal',
  templateUrl: './lines-detail-modal.component.html',
  styleUrls: ['./lines-detail-modal.component.css'],
})
export class LinesDetailModalComponent extends BaseComponent {
  /** Inicializa el modal de líneas */
  constructor(
    /** Referencia a componente dentro del modal */
    public modalRef: BsModalRef,
    /** Opciones de la ventana modal */
    options: ModalOptions,
    /** Servicio de líneas */
    public service: UserViewService
  ) {
    super();
    options.class = 'lines';
    this.service = new LinesService(
      inject(HttpClient),
      options.initialState.linesEndpoint as string
    );
  }

  /** Variable para utilizar el componente de búsqueda */
  @ViewChild(UserViewComponent, { static: true })
  viewComponent: UserViewComponent;
  /** Almacena el valor de la búsqueda */
  searchValue: string;
  /** Endpoint para el servicio de líneas */
  linesEndpoint: string;

  get metadata(): UserViewMetadata {
    return this.viewComponent.metadata;
  }

  ngOnInit() {
    this.viewComponent.initialized.subscribe(() => {
      this.initialize();
    });
  }

  /** Inicializa la búsqueda */
  private initialize() {
    if(this.linesEndpoint === "lines-orders-article"){
       this.viewComponent.grid.api.getColumnDef('ReceptionOrder').headerName =
       this.viewComponent.metadata.Search.Properties.Reference.Text;
    }
    this.viewComponent.grid.api.refreshHeader();    
    this.viewComponent.frm.controls.Reference.setValue(this.searchValue);
  }
}
